const STORAGE_KEY = {
    VMP_USER: '@jitsi-meet/features/vmp-user',
    TOKEN: 'TOKEN',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    MOBILE_SYSTEM: '@jitsi-meet/features/mobile-system',
    API_DOMAIN: 'API_DOMAIN',
    API_MEETING_DOMAIN: 'API_MEETING_DOMAIN',
    API_SSO_DOMAIN: 'API_SSO_DOMAIN',
    DEEP_LINK: 'DEEP_LINK',
    DEEP_LINK_ID: 'DEEP_LINK_ID',
    PREJOIN_LOGIN_ID: 'PREJOIN_LOGIN_ID'
};
export default STORAGE_KEY;
